export default "/_next/static/assets/ClearSans_3ed943964e7f8c06886ba59fe3429d55.woff2";